import React, { useState, useEffect } from 'react';
import { XMarkIcon, ChevronDownIcon, TrashIcon, MagnifyingGlassIcon } from '@heroicons/react/24/solid';
import { deleteBudget } from '../api/budgets';
import ConfirmDialog from './ConfirmDialog';

const ICON_OPTIONS = [
  // Money & Finance
  { label: 'Dollar', value: 'fas fa-dollar-sign', category: 'Money & Finance' },
  { label: 'Credit Card', value: 'fas fa-credit-card', category: 'Money & Finance' },
  { label: 'Wallet', value: 'fas fa-wallet', category: 'Money & Finance' },
  { label: 'Piggy Bank', value: 'fas fa-piggy-bank', category: 'Money & Finance' },
  { label: 'Coins', value: 'fas fa-coins', category: 'Money & Finance' },
  { label: 'Money Bill', value: 'fas fa-money-bill', category: 'Money & Finance' },
  { label: 'Chart Line', value: 'fas fa-chart-line', category: 'Money & Finance' },
  { label: 'Calculator', value: 'fas fa-calculator', category: 'Money & Finance' },
  
  // Food & Dining
  { label: 'Utensils', value: 'fas fa-utensils', category: 'Food & Dining' },
  { label: 'Coffee', value: 'fas fa-coffee', category: 'Food & Dining' },
  { label: 'Pizza Slice', value: 'fas fa-pizza-slice', category: 'Food & Dining' },
  { label: 'Hamburger', value: 'fas fa-hamburger', category: 'Food & Dining' },
  { label: 'Ice Cream', value: 'fas fa-ice-cream', category: 'Food & Dining' },
  { label: 'Wine Glass', value: 'fas fa-wine-glass', category: 'Food & Dining' },
  { label: 'Beer', value: 'fas fa-beer', category: 'Food & Dining' },
  { label: 'Apple Alt', value: 'fas fa-apple-alt', category: 'Food & Dining' },
  { label: 'Carrot', value: 'fas fa-carrot', category: 'Food & Dining' },
  
  // Transportation
  { label: 'Gas Pump', value: 'fas fa-gas-pump', category: 'Transportation' },
  { label: 'Car', value: 'fas fa-car', category: 'Transportation' },
  { label: 'Car Side', value: 'fas fa-car-side', category: 'Transportation' },
  { label: 'Motorcycle', value: 'fas fa-motorcycle', category: 'Transportation' },
  { label: 'Bicycle', value: 'fas fa-bicycle', category: 'Transportation' },
  { label: 'Plane', value: 'fas fa-plane', category: 'Transportation' },
  { label: 'Train', value: 'fas fa-train', category: 'Transportation' },
  { label: 'Bus', value: 'fas fa-bus', category: 'Transportation' },
  { label: 'Ship', value: 'fas fa-ship', category: 'Transportation' },
  { label: 'Taxi', value: 'fas fa-taxi', category: 'Transportation' },
  { label: 'Truck', value: 'fas fa-truck', category: 'Transportation' },
  
  // Home & Living
  { label: 'Home', value: 'fas fa-home', category: 'Home & Living' },
  { label: 'Couch', value: 'fas fa-couch', category: 'Home & Living' },
  { label: 'Bed', value: 'fas fa-bed', category: 'Home & Living' },
  { label: 'Chair', value: 'fas fa-chair', category: 'Home & Living' },
  { label: 'Lightbulb', value: 'fas fa-lightbulb', category: 'Home & Living' },
  { label: 'Wrench', value: 'fas fa-wrench', category: 'Home & Living' },
  { label: 'Hammer', value: 'fas fa-hammer', category: 'Home & Living' },
  { label: 'Paint Roller', value: 'fas fa-paint-roller', category: 'Home & Living' },
  { label: 'Tools', value: 'fas fa-tools', category: 'Home & Living' },
  { label: 'Shower', value: 'fas fa-shower', category: 'Home & Living' },
  { label: 'Bath', value: 'fas fa-bath', category: 'Home & Living' },
  { label: 'Toilet', value: 'fas fa-toilet', category: 'Home & Living' },
  
  // Shopping & Retail
  { label: 'Shopping Cart', value: 'fas fa-shopping-cart', category: 'Shopping & Retail' },
  { label: 'Shopping Bag', value: 'fas fa-shopping-bag', category: 'Shopping & Retail' },
  { label: 'Store', value: 'fas fa-store', category: 'Shopping & Retail' },
  { label: 'Tags', value: 'fas fa-tags', category: 'Shopping & Retail' },
  { label: 'Tag', value: 'fas fa-tag', category: 'Shopping & Retail' },
  { label: 'Gift', value: 'fas fa-gift', category: 'Shopping & Retail' },
  { label: 'Box', value: 'fas fa-box', category: 'Shopping & Retail' },
  { label: 'Boxes', value: 'fas fa-boxes', category: 'Shopping & Retail' },
  { label: 'Tshirt', value: 'fas fa-tshirt', category: 'Shopping & Retail' },
  { label: 'Shoe Prints', value: 'fas fa-shoe-prints', category: 'Shopping & Retail' },
  { label: 'Gem', value: 'fas fa-gem', category: 'Shopping & Retail' },
  { label: 'Ring', value: 'fas fa-ring', category: 'Shopping & Retail' },
  
  // Entertainment & Leisure
  { label: 'Heart', value: 'fas fa-heart', category: 'Entertainment & Leisure' },
  { label: 'Gamepad', value: 'fas fa-gamepad', category: 'Entertainment & Leisure' },
  { label: 'Film', value: 'fas fa-film', category: 'Entertainment & Leisure' },
  { label: 'Video', value: 'fas fa-video', category: 'Entertainment & Leisure' },
  { label: 'Music', value: 'fas fa-music', category: 'Entertainment & Leisure' },
  { label: 'Headphones', value: 'fas fa-headphones', category: 'Entertainment & Leisure' },
  { label: 'Tv', value: 'fas fa-tv', category: 'Entertainment & Leisure' },
  { label: 'Theater Masks', value: 'fas fa-theater-masks', category: 'Entertainment & Leisure' },
  { label: 'Ticket Alt', value: 'fas fa-ticket-alt', category: 'Entertainment & Leisure' },
  { label: 'Dice', value: 'fas fa-dice', category: 'Entertainment & Leisure' },
  { label: 'Puzzle Piece', value: 'fas fa-puzzle-piece', category: 'Entertainment & Leisure' },
  { label: 'Book', value: 'fas fa-book', category: 'Entertainment & Leisure' },
  { label: 'Newspaper', value: 'fas fa-newspaper', category: 'Entertainment & Leisure' },
  { label: 'Camera', value: 'fas fa-camera', category: 'Entertainment & Leisure' },
  { label: 'Palette', value: 'fas fa-palette', category: 'Entertainment & Leisure' },
  { label: 'Pencil Alt', value: 'fas fa-pencil-alt', category: 'Entertainment & Leisure' },
  
  // Health & Fitness
  { label: 'Dumbbell', value: 'fas fa-dumbbell', category: 'Health & Fitness' },
  { label: 'Running', value: 'fas fa-running', category: 'Health & Fitness' },
  { label: 'Biking', value: 'fas fa-biking', category: 'Health & Fitness' },
  { label: 'Swimming Pool', value: 'fas fa-swimming-pool', category: 'Health & Fitness' },
  { label: 'Hiking', value: 'fas fa-hiking', category: 'Health & Fitness' },
  { label: 'Skiing', value: 'fas fa-skiing', category: 'Health & Fitness' },
  { label: 'Snowboarding', value: 'fas fa-snowboarding', category: 'Health & Fitness' },
  { label: 'Golf Ball', value: 'fas fa-golf-ball', category: 'Health & Fitness' },
  { label: 'Basketball Ball', value: 'fas fa-basketball-ball', category: 'Health & Fitness' },
  { label: 'Football Ball', value: 'fas fa-football-ball', category: 'Health & Fitness' },
  { label: 'Baseball Ball', value: 'fas fa-baseball-ball', category: 'Health & Fitness' },
  { label: 'Table Tennis', value: 'fas fa-table-tennis', category: 'Health & Fitness' },
  { label: 'Volleyball Ball', value: 'fas fa-volleyball-ball', category: 'Health & Fitness' },
  { label: 'Heartbeat', value: 'fas fa-heartbeat', category: 'Health & Fitness' },
  { label: 'Stethoscope', value: 'fas fa-stethoscope', category: 'Health & Fitness' },
  { label: 'Pills', value: 'fas fa-pills', category: 'Health & Fitness' },
  { label: 'First Aid', value: 'fas fa-first-aid', category: 'Health & Fitness' },
  { label: 'Cut', value: 'fas fa-cut', category: 'Health & Fitness' },
  { label: 'User', value: 'fas fa-user', category: 'Health & Fitness' },
  
  // Education & Work
  { label: 'Graduation Cap', value: 'fas fa-graduation-cap', category: 'Education & Work' },
  { label: 'School', value: 'fas fa-school', category: 'Education & Work' },
  { label: 'University', value: 'fas fa-university', category: 'Education & Work' },
  { label: 'Laptop', value: 'fas fa-laptop', category: 'Education & Work' },
  { label: 'Desktop', value: 'fas fa-desktop', category: 'Education & Work' },
  { label: 'Mobile', value: 'fas fa-mobile-alt', category: 'Education & Work' },
  { label: 'Tablet Alt', value: 'fas fa-tablet-alt', category: 'Education & Work' },
  { label: 'Briefcase', value: 'fas fa-briefcase', category: 'Education & Work' },
  { label: 'Suitcase', value: 'fas fa-suitcase', category: 'Education & Work' },
  { label: 'Clipboard', value: 'fas fa-clipboard', category: 'Education & Work' },
  { label: 'File', value: 'fas fa-file', category: 'Education & Work' },
  { label: 'Folder', value: 'fas fa-folder', category: 'Education & Work' },
  { label: 'Envelope', value: 'fas fa-envelope', category: 'Education & Work' },
  { label: 'Phone', value: 'fas fa-phone', category: 'Education & Work' },
  { label: 'Fax', value: 'fas fa-fax', category: 'Education & Work' },
  { label: 'Printer', value: 'fas fa-print', category: 'Education & Work' },
  { label: 'Paperclip', value: 'fas fa-paperclip', category: 'Education & Work' },
  
  // Utilities & Services
  { label: 'Wifi', value: 'fas fa-wifi', category: 'Utilities & Services' },
  { label: 'Bolt', value: 'fas fa-bolt', category: 'Utilities & Services' },
  { label: 'Fire', value: 'fas fa-fire', category: 'Utilities & Services' },
  { label: 'Water', value: 'fas fa-tint', category: 'Utilities & Services' },
  { label: 'Recycle', value: 'fas fa-recycle', category: 'Utilities & Services' },
  { label: 'Trash', value: 'fas fa-trash', category: 'Utilities & Services' },
  { label: 'Trash Alt', value: 'fas fa-trash-alt', category: 'Utilities & Services' },
  { label: 'Leaf', value: 'fas fa-leaf', category: 'Utilities & Services' },
  { label: 'Seedling', value: 'fas fa-seedling', category: 'Utilities & Services' },
  { label: 'Tree', value: 'fas fa-tree', category: 'Utilities & Services' },
  { label: 'Cloud', value: 'fas fa-cloud', category: 'Utilities & Services' },
  { label: 'Sun', value: 'fas fa-sun', category: 'Utilities & Services' },
  { label: 'Moon', value: 'fas fa-moon', category: 'Utilities & Services' },
  { label: 'Snowflake', value: 'fas fa-snowflake', category: 'Utilities & Services' },
  { label: 'Umbrella', value: 'fas fa-umbrella', category: 'Utilities & Services' },
  
  // Pets & Animals
  { label: 'Dog', value: 'fas fa-dog', category: 'Pets & Animals' },
  { label: 'Cat', value: 'fas fa-cat', category: 'Pets & Animals' },
  { label: 'Fish', value: 'fas fa-fish', category: 'Pets & Animals' },
  { label: 'Horse', value: 'fas fa-horse', category: 'Pets & Animals' },
  { label: 'Paw', value: 'fas fa-paw', category: 'Pets & Animals' },
  { label: 'Bone', value: 'fas fa-bone', category: 'Pets & Animals' },
  { label: 'Feather', value: 'fas fa-feather', category: 'Pets & Animals' },
  { label: 'Egg', value: 'fas fa-egg', category: 'Pets & Animals' },
  
  // Travel & Places
  { label: 'Map', value: 'fas fa-map', category: 'Travel & Places' },
  { label: 'Map Marker', value: 'fas fa-map-marker-alt', category: 'Travel & Places' },
  { label: 'Globe', value: 'fas fa-globe', category: 'Travel & Places' },
  { label: 'Globe Americas', value: 'fas fa-globe-americas', category: 'Travel & Places' },
  { label: 'Globe Europe', value: 'fas fa-globe-europe', category: 'Travel & Places' },
  { label: 'Globe Asia', value: 'fas fa-globe-asia', category: 'Travel & Places' },
  { label: 'Mountain', value: 'fas fa-mountain', category: 'Travel & Places' },
  { label: 'Campground', value: 'fas fa-campground', category: 'Travel & Places' },
  { label: 'Umbrella Beach', value: 'fas fa-umbrella-beach', category: 'Travel & Places' },
  { label: 'Hotel', value: 'fas fa-hotel', category: 'Travel & Places' },
  { label: 'Building', value: 'fas fa-building', category: 'Travel & Places' },
  { label: 'Industry', value: 'fas fa-industry', category: 'Travel & Places' },
  { label: 'Warehouse', value: 'fas fa-warehouse', category: 'Travel & Places' },
  { label: 'Store Alt', value: 'fas fa-store-alt', category: 'Travel & Places' },
  
  // Special Occasions & Events
  { label: 'Birthday Cake', value: 'fas fa-birthday-cake', category: 'Special Occasions & Events' },
  { label: 'Calendar', value: 'fas fa-calendar', category: 'Special Occasions & Events' },
  { label: 'Calendar Alt', value: 'fas fa-calendar-alt', category: 'Special Occasions & Events' },
  { label: 'Clock', value: 'fas fa-clock', category: 'Special Occasions & Events' },
  { label: 'Stopwatch', value: 'fas fa-stopwatch', category: 'Special Occasions & Events' },
  { label: 'Hourglass', value: 'fas fa-hourglass', category: 'Special Occasions & Events' },
  { label: 'Bell', value: 'fas fa-bell', category: 'Special Occasions & Events' },
  { label: 'Star', value: 'fas fa-star', category: 'Special Occasions & Events' },
  { label: 'Crown', value: 'fas fa-crown', category: 'Special Occasions & Events' },
  { label: 'Trophy', value: 'fas fa-trophy', category: 'Special Occasions & Events' },
  { label: 'Medal', value: 'fas fa-medal', category: 'Special Occasions & Events' },
  { label: 'Award', value: 'fas fa-award', category: 'Special Occasions & Events' },
  { label: 'Certificate', value: 'fas fa-certificate', category: 'Special Occasions & Events' },
  { label: 'Ribbon', value: 'fas fa-ribbon', category: 'Special Occasions & Events' },
  { label: 'Flag', value: 'fas fa-flag', category: 'Special Occasions & Events' },
  
  // Miscellaneous
  { label: 'Smile', value: 'fas fa-smile', category: 'Miscellaneous' },
  { label: 'Laugh', value: 'fas fa-laugh', category: 'Miscellaneous' },
  { label: 'Thumbs Up', value: 'fas fa-thumbs-up', category: 'Miscellaneous' },
  { label: 'Handshake', value: 'fas fa-handshake', category: 'Miscellaneous' },
  { label: 'Pray', value: 'fas fa-pray', category: 'Miscellaneous' },
  { label: 'Peace', value: 'fas fa-peace', category: 'Miscellaneous' },
  { label: 'Infinity', value: 'fas fa-infinity', category: 'Miscellaneous' },
  { label: 'Magic', value: 'fas fa-magic', category: 'Miscellaneous' },
  { label: 'Ghost', value: 'fas fa-ghost', category: 'Miscellaneous' },
  { label: 'Skull', value: 'fas fa-skull', category: 'Miscellaneous' },
  { label: 'Robot', value: 'fas fa-robot', category: 'Miscellaneous' },
  { label: 'Rocket', value: 'fas fa-rocket', category: 'Miscellaneous' },
  { label: 'Satellite', value: 'fas fa-satellite', category: 'Miscellaneous' }
];

export function BudgetAddEdit({
  open,
  onClose,
  onSave,
  onDelete,
  initial,
  isEdit = false,
}: {
  open: boolean;
  onClose: () => void;
  onSave: (budget: { name: string; amount: number; icon: string; budgetType: 'Expense' | 'Savings' | 'Expense Fund'; savingsGoal?: 'Target Goal' | 'Monthly Goal'; targetDate?: string; expensePeriodValue?: number; expensePeriodUnit?: 'Months' | 'Years'; id?: string }) => void;
  onDelete?: () => void;
  initial?: { name: string; amount: number; icon: string; budgetType?: 'Expense' | 'Savings' | 'Expense Fund'; savingsGoal?: 'Target Goal' | 'Monthly Goal'; targetDate?: string; expensePeriodValue?: number; expensePeriodUnit?: 'Months' | 'Years'; id?: string };
  isEdit?: boolean;
}) {
  const [name, setName] = useState(initial?.name || '');
  const [amount, setAmount] = useState(initial?.amount?.toString() || '');
  const [budgetType, setBudgetType] = useState<'Expense' | 'Savings' | 'Expense Fund'>((initial as any)?.budgetType || 'Expense');
  const [savingsGoal, setSavingsGoal] = useState<'Target Goal' | 'Monthly Goal'>((initial as any)?.savingsGoal || 'Monthly Goal');
  const [targetDate, setTargetDate] = useState((initial as any)?.targetDate || '');
  const [expensePeriodValue, setExpensePeriodValue] = useState((initial as any)?.expensePeriodValue?.toString() || '');
  const [expensePeriodUnit, setExpensePeriodUnit] = useState<'Months' | 'Years'>((initial as any)?.expensePeriodUnit || 'Months');
  const [icon, setIcon] = useState(initial?.icon || ICON_OPTIONS[0].value);
  const [iconDropdownOpen, setIconDropdownOpen] = useState(false);
  const [iconSearch, setIconSearch] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  useEffect(() => {
    setName(initial?.name || '');
    setAmount(initial?.amount?.toString() || '');
    setBudgetType((initial as any)?.budgetType || 'Expense');
    setSavingsGoal((initial as any)?.savingsGoal || 'Monthly Goal');
    setTargetDate((initial as any)?.targetDate || '');
    setExpensePeriodValue((initial as any)?.expensePeriodValue?.toString() || '');
    setExpensePeriodUnit((initial as any)?.expensePeriodUnit || 'Months');
    setIcon(initial?.icon || ICON_OPTIONS[0].value);
  }, [initial]);

  // Calculate monthly amount for expense funds
  const calculateMonthlyAmount = () => {
    if (budgetType !== 'Expense Fund' || !expensePeriodValue || !amount) return 0;
    const periodValue = parseFloat(expensePeriodValue);
    const totalAmount = parseFloat(amount);
    if (expensePeriodUnit === 'Years') {
      return totalAmount / (periodValue * 12);
    } else {
      return totalAmount / periodValue;
    }
  };

  const monthlyAmount = calculateMonthlyAmount();

  // Filter icons based on search
  const filteredIcons = ICON_OPTIONS.filter(option =>
    option.label.toLowerCase().includes(iconSearch.toLowerCase()) ||
    option.category.toLowerCase().includes(iconSearch.toLowerCase())
  );

  // Group filtered icons by category
  const groupedIcons = filteredIcons.reduce((groups, icon) => {
    const category = icon.category;
    if (!groups[category]) {
      groups[category] = [];
    }
    groups[category].push(icon);
    return groups;
  }, {} as Record<string, typeof ICON_OPTIONS>);

  const handleDeleteClick = () => {
    setShowDeleteConfirm(true);
  };

  const handleDeleteConfirm = async () => {
    if (!initial?.id || !onDelete) return;

    setIsDeleting(true);
    setShowDeleteConfirm(false);
    
    try {
      await deleteBudget(initial.id);
      onDelete();
      onClose();
    } catch (error) {
      console.error('Failed to delete budget:', error);
      alert('Failed to delete budget. Please try again.');
    } finally {
      setIsDeleting(false);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteConfirm(false);
  };

  const handleSave = () => {
    onSave({ 
      name, 
      amount: parseFloat(amount), 
      icon, 
      budgetType, 
      savingsGoal: budgetType === 'Savings' ? savingsGoal : undefined,
      targetDate: budgetType === 'Savings' && savingsGoal === 'Target Goal' ? targetDate : undefined,
      expensePeriodValue: budgetType === 'Expense Fund' ? parseFloat(expensePeriodValue) : undefined,
      expensePeriodUnit: budgetType === 'Expense Fund' ? expensePeriodUnit : undefined,
      id: initial?.id 
    });
    
    // Clear form if this is a new budget (not editing)
    if (!isEdit) {
      setName('');
      setAmount('');
      setBudgetType('Expense');
      setSavingsGoal('Monthly Goal');
      setTargetDate('');
      setExpensePeriodValue('');
      setExpensePeriodUnit('Months');
      setIcon(ICON_OPTIONS[0].value);
      setIconSearch('');
    }
  };

  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 z-50 bg-white flex flex-col w-full max-w-4xl mx-auto">
      {/* Header */}
        <div className="flex items-center justify-between py-6 px-6 border-b border-gray-100">
          <span className="text-xl font-semibold text-gray-900">{isEdit ? 'Edit Budget' : 'Add Budget'}</span>
        <button
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          onClick={onClose}
          aria-label="Close"
        >
            <XMarkIcon className="w-6 h-6 text-gray-500" />
        </button>
      </div>

        {/* Form Content */}
        <div className="flex-1 overflow-y-auto">
          <div className="px-6 py-8 space-y-6">
            {/* Budget Type Selector - First Field */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="budget-type">
                Budget Type <span className="text-red-500">*</span>
              </label>
              <select
                id="budget-type"
                value={budgetType}
                onChange={(e) => setBudgetType(e.target.value as 'Expense' | 'Savings' | 'Expense Fund')}
                className="w-full rounded-xl px-4 py-3 border border-gray-200 bg-gray-50 text-base font-medium text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 focus:bg-white transition-all"
              >
                <option value="Expense">Expense - Track spending against a limit</option>
                <option value="Expense Fund">Expense Fund - Save for future expenses</option>
                <option value="Savings">Savings - Track progress toward a goal</option>
              </select>
            </div>

            {/* Savings Goal Selector - Only for Savings */}
            {budgetType === 'Savings' && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="savings-goal">
                  Goal <span className="text-red-500">*</span>
                </label>
                <select
                  id="savings-goal"
                  value={savingsGoal}
                  onChange={(e) => setSavingsGoal(e.target.value as 'Target Goal' | 'Monthly Goal')}
                  className="w-full rounded-xl px-4 py-3 border border-gray-200 bg-gray-50 text-base font-medium text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 focus:bg-white transition-all"
                >
                  <option value="Target Goal">Target Goal - Save for a specific amount by a date</option>
                  <option value="Monthly Goal">Monthly Goal - Save a set amount each month</option>
                </select>
              </div>
            )}

            {/* Expense Period Fields - Only for Expense Fund */}
            {budgetType === 'Expense Fund' && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="expense-period">
                  Expense Period <span className="text-red-500">*</span>
                </label>
                <div className="flex gap-2">
                  <input
                    id="expense-period"
                    type="number"
                    min="1"
                    className="flex-1 rounded-xl px-4 py-3 border border-gray-200 bg-gray-50 text-base font-medium text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 focus:bg-white transition-all"
                    value={expensePeriodValue}
                    onChange={e => setExpensePeriodValue(e.target.value)}
                    placeholder="6"
                    required
                  />
                  <select
                    value={expensePeriodUnit}
                    onChange={(e) => setExpensePeriodUnit(e.target.value as 'Months' | 'Years')}
                    className="rounded-xl px-4 py-3 border border-gray-200 bg-gray-50 text-base font-medium text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 focus:bg-white transition-all"
                  >
                    <option value="Months">Months</option>
                    <option value="Years">Years</option>
                  </select>
                </div>
              </div>
            )}

            {/* Name Input */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="budget-name">
                Budget Name <span className="text-red-500">*</span>
              </label>
              <input
                id="budget-name"
                type="text"
                className="w-full rounded-xl px-4 py-3 border border-gray-200 bg-gray-50 text-base font-medium text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 focus:bg-white transition-all"
                value={name}
                onChange={e => setName(e.target.value)}
                placeholder="e.g., Groceries, Emergency Fund"
                required
              />
            </div>

            {/* Amount Input */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="budget-amount">
                {budgetType === 'Savings' 
                  ? (savingsGoal === 'Target Goal' ? 'Target Goal' : 'Monthly Goal')
                  : budgetType === 'Expense Fund'
                  ? 'Amount per Period'
                  : 'Monthly Budget'
                } <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <span className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500 font-medium">$</span>
                <input
                  id="budget-amount"
                  type="number"
                  min="0"
                  step="0.01"
                  className="w-full rounded-xl pl-8 pr-4 py-3 border border-gray-200 bg-gray-50 text-base font-medium text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 focus:bg-white transition-all"
                  value={amount}
                  onChange={e => setAmount(e.target.value)}
                  placeholder="0.00"
                  required
                />
              </div>
              {/* Monthly Amount Display - Only for Expense Fund */}
              {budgetType === 'Expense Fund' && monthlyAmount > 0 && (
                <div className="mt-2 text-sm text-gray-600">
                  <span className="font-medium">Monthly amount needed: </span>
                  <span className="font-semibold text-green-600">
                    ${monthlyAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </span>
                </div>
              )}
            </div>

            {/* Target Date - Only for Savings with Target Goal */}
            {budgetType === 'Savings' && savingsGoal === 'Target Goal' && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="target-date">
                  Target Date <span className="text-red-500">*</span>
                </label>
                <input
                  id="target-date"
                  type="date"
                  className="w-full rounded-xl px-4 py-3 border border-gray-200 bg-gray-50 text-base font-medium text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 focus:bg-white transition-all"
                  value={targetDate}
                  onChange={e => setTargetDate(e.target.value)}
                  required
                />
              </div>
            )}

            {/* Icon Selector */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Icon
              </label>
        <div className="relative">
          <button
            type="button"
                  className="w-full flex items-center justify-between rounded-xl px-4 py-3 border border-gray-200 bg-gray-50 text-base font-medium text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 focus:bg-white transition-all hover:bg-gray-100"
            onClick={() => setIconDropdownOpen(o => !o)}
          >
                  <div className="flex items-center gap-3">
                    <i className={`${icon} text-lg text-gray-600`} aria-hidden="true"></i>
                    <span className="text-gray-800">{ICON_OPTIONS.find(opt => opt.value === icon)?.label}</span>
                  </div>
                  <ChevronDownIcon className={`w-5 h-5 text-gray-400 transition-transform ${iconDropdownOpen ? 'rotate-180' : ''}`} />
          </button>
                
          {iconDropdownOpen && (
                  <div className="absolute left-0 right-0 mt-2 bg-white rounded-xl border border-gray-200 shadow-lg z-10 max-h-80 overflow-hidden">
                    {/* Search Box */}
                    <div className="p-3 border-b border-gray-100">
                      <div className="relative">
                        <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                        <input
                          type="text"
                          placeholder="Search icons..."
                          value={iconSearch}
                          onChange={(e) => setIconSearch(e.target.value)}
                          className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                        />
                      </div>
                    </div>
                    
                    {/* Icon List */}
                    <div className="max-h-60 overflow-y-auto">
                      {Object.entries(groupedIcons).map(([category, icons]) => (
                        <div key={category}>
                          {/* Category Header */}
                          <div className="px-4 py-2 bg-gray-50 border-b border-gray-100">
                            <h3 className="text-xs font-semibold text-gray-600 uppercase tracking-wide">{category}</h3>
                          </div>
                          
                          {/* Icons in Category */}
                          {icons.map(opt => (
                <button
                  key={opt.value}
                              className={`w-full flex items-center gap-3 px-4 py-3 text-base font-medium hover:bg-gray-50 transition-colors ${
                                icon === opt.value 
                                  ? 'text-green-600 font-semibold bg-green-50' 
                                  : 'text-gray-700'
                              }`}
                              onClick={() => { setIcon(opt.value); setIconDropdownOpen(false); setIconSearch(''); }}
                  type="button"
                >
                              <div className="w-6 flex justify-center">
                                <i className={`${opt.value} text-lg`} aria-hidden="true"></i>
                              </div>
                  <span>{opt.label}</span>
                </button>
              ))}
                        </div>
                      ))}
                      
                      {filteredIcons.length === 0 && (
                        <div className="px-4 py-8 text-center text-gray-500">
                          No icons found matching "{iconSearch}"
                        </div>
                      )}
                    </div>
            </div>
          )}
        </div>
      </div>
            </div>
          </div>

        {/* Action Buttons */}
        <div className="border-t border-gray-100 px-6 py-6 space-y-3">
      {/* Save Button */}
      <button
            className={`w-full py-4 rounded-xl text-lg font-semibold transition-all ${
              !name.trim() || !amount || parseFloat(amount) <= 0
                ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                : 'bg-green-500 text-white hover:bg-green-600 active:scale-[0.98]'
            }`}
            onClick={handleSave}
            disabled={!name.trim() || !amount || parseFloat(amount) <= 0}
        aria-label="Save budget"
      >
            {isEdit ? 'Update Budget' : 'Create Budget'}
          </button>
          
          {/* Delete Button - Only show in edit mode */}
          {isEdit && initial?.id && (
            <button
              className="w-full py-3 rounded-xl border-2 border-red-200 text-red-600 text-base font-medium flex items-center justify-center gap-2 hover:bg-red-50 hover:border-red-300 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={handleDeleteClick}
              disabled={isDeleting}
              aria-label="Delete budget"
            >
              <TrashIcon className="w-4 h-4" />
              {isDeleting ? 'Deleting...' : 'Delete Budget'}
      </button>
          )}
        </div>
    </div>

      {/* Confirmation Dialog */}
      <ConfirmDialog
        open={showDeleteConfirm}
        title="Delete Budget"
        message={`Are you sure you want to delete "${initial?.name}"? This action cannot be undone and will permanently remove this budget and all associated data.`}
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
        type="danger"
      />
    </>
  );
} 